<!-- QuoteBaseModal.vue: full-screen layer that hosts the stock details page. -->

<template>
  <div class="base-modal">
    <!-- Opaque so the screener underneath never shows through while a tab is loading. -->
    <div ref="scroller" class="fixed base-modal inset-0 overflow-y-auto overscroll-contain bg-canvas" role="dialog"
      aria-modal="true">
      <div class="flex items-center justify-center min-h-full  text-center sm:p-0">
        <div @click.stop :class="customClass" class="relative w-full overflow-x-clip text-left">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Esc emits `close`, unless a nested dialog or menu handled the key first.
export default {
  props: {
    customClass: {
      type: String,
      default: "",
    },
  },
  mounted() {
    document.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    onKeydown(e) {
      if (e.key === "Escape" && !e.defaultPrevented) this.$emit("close");
    },
  },
};
</script>

<style scoped>
.base-modal {
  z-index: 1000;
}
</style>
